import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {DisplayedColumnInf} from '../../../../../interfaces/common/table/displayed-column-inf';
import {ArmTableComponent} from '../../../../../components/arm-table/arm-table.component';
import {UserPrivilegeService} from '../../../../../services/common/user-privilege/user-privilege.service';
import {
  CredentialsSettingsApiService
} from '../../../../../services/api/settings/administration/credentials/credentials-settings-api.service';
import {OperatorRoleType} from '../../../../../services/enums/operator-role-type.enum';
import {LoaderService} from '../../../../../services/common/loader-service/loader.service';
import {AcDialogService} from 'ac-infra';
import {SnackBarService} from '../../../../../services/common/snack-bar/snack-bar.service';
import {CredentialsDialogComponent} from '../credentials-dialog/credentials-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {ConfirmationDialogComponent} from '../../../../../dialogs/confirmation-dialog/confirmation-dialog.component';
import _ from 'lodash';
import {RoleTypeEnum} from '../../../../../services/enums/role-type.enum';

@Component({
  selector: 'credentials-table',
  templateUrl: './credentials-table.component.html',
  styleUrls: ['./credentials-table.component.scss']
})
export class CredentialsTableComponent implements OnInit {

  @ViewChild(ArmTableComponent) armTable;
  @Input() type;

  selection: any;

  displayedColumns: Array<DisplayedColumnInf> = [
    {name: 'description', display: 'Identifier name', selected: true,  width: 150},
    {name: 'userName', display: 'User name', selected: true, width: 150},
    {name: 'type', display: 'Type', selected: true, width: 150},
  ];

  items: any[];
  isUnauthorized: boolean;

  constructor(private userPrivilege: UserPrivilegeService,
              private credentialsSettingsApiService: CredentialsSettingsApiService,
              private loaderService: LoaderService,
              private acDialogService: AcDialogService,
              private snackBarService: SnackBarService,
              private dialog: MatDialog) { }

  ngOnInit(): void {
    this.loaderService.showMainContainer();
    this.isUnauthorized = !this.userPrivilege.isAuthorized(RoleTypeEnum.SECURITY_ADMIN);
    this.refresh();
  }

  addItem(): void {
    const dialogData = {
      isEditMode: false,
      selectedItem: {userName: '', type: this.type, passwordConfirm: null},
      type: this.type
    };

    this.acDialogService.open(CredentialsDialogComponent, {
      dialogData,
      onSubmit: () => {
        delete dialogData.selectedItem.passwordConfirm;
        this.credentialsSettingsApiService.addNewCredentials(dialogData.selectedItem).subscribe(() => {
          this.snackBarService.display(`"${dialogData.selectedItem.userName}" successfully added`);
          this.refresh();
        });
      },
      title: `Add ${this.type === 'ROUTER' ? 'Router' : 'Node' } Credentials`
    });
  }

  removeItem(): void {
    const confirmationDialog = this.dialog.open(ConfirmationDialogComponent, {
      disableClose: true,
      width: '460px',
      data: {
        message: `Are you sure you want to delete the credentials: "${this.selection.description}" ?`
      }
    });

    confirmationDialog.componentInstance.onApply.subscribe(() => {
      this.credentialsSettingsApiService.deleteCredentials(this.selection.id).subscribe(() => {
        confirmationDialog.close();
        this.snackBarService.display(`"${this.selection.userName}" successfully deleted`);
        this.refresh();
      });
    });
  }

  refresh(): void {
    this.credentialsSettingsApiService.getCredentials(this.type, {}).subscribe(data => {
      this.items = data;
      this.loaderService.hideMainContainer();
    });
  }

  editItem(): void {
    const dialogData = {
      isEditMode: true,
      selectedItem: _.cloneDeep(this.selection),
      type: this.type
    };

    this.acDialogService.open(CredentialsDialogComponent, {
      dialogData,
      onSubmit: () => {
        this.credentialsSettingsApiService.updateCredentials(dialogData.selectedItem).subscribe(() => {
          this.snackBarService.display(`"${dialogData.selectedItem.userName}" successfully updated`);
          this.refresh();
        });
      },
      title: `Update ${this.type === 'ROUTER' ? 'Router' : 'Node' } Credentials`
    });
  }

  onSelection(selection: any): void {
    this.selection = selection;
  }
}
